export default __webpack_public_path__ + "static/media/requests_form.147ab671.xlsx";